import script from "./QuestionCorrectAnswerRate.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionCorrectAnswerRate.vue?vue&type=script&setup=true&lang=js"

import "./QuestionCorrectAnswerRate.vue?vue&type=style&index=0&id=360ee7d3&scoped=true&lang=css"
script.__scopeId = "data-v-360ee7d3"

export default script